import React from 'react'

import { QA } from '@hozana/tests/constants'
import { TRACKING_SOURCE } from '@hozana/tracking/constants'

import { Block } from 'elements/layout/Block'
import { Div } from 'elements/layout/Div'
import { Space } from 'elements/layout/Space'
import { Separator } from 'elements/ui/Separator'

import { CommunityCheckExplanation } from 'modules/community/components/CommunityCheckExplanation'
import { CommunityDraftExplanation } from 'modules/community/components/CommunityDraftExplanation'
import { CommunityMembers } from 'modules/community/components/CommunityMembers'
import { JoinButton } from 'modules/community/components/JoinButton'
import { COMMUNITY_STATUS } from 'modules/community/constants'
import { getUserRole } from 'modules/community/functions'
import type { TCommunity } from 'modules/community/types'

import { CommunitySubscriptionButtons } from '../CommunitySubscriptionButtons'
import { UserInfoSection } from '../UserInfoSection'
import { CommunitySharesDesktop } from './CommunitySharesDesktop'

export type TCommunitySidebarProps = {
  community: TCommunity
  distanceFromTop?: number
}

export const CommunitySidebar: TFC<TCommunitySidebarProps> = ({ community, distanceFromTop }) => {
  const isDraft = community?.status === COMMUNITY_STATUS.DRAFT
  const isCheck = community?.status === COMMUNITY_STATUS.CHECK
  const roles = getUserRole(community)
  const communityDetailsInSidebar = distanceFromTop > 600
  const communityShareInSidebar = !isDraft && !isCheck

  return (
    <>
      {(communityDetailsInSidebar || communityShareInSidebar) && (
        <>
          <Space />
          <Block square h="100%" p="10px 1em" data-testid={QA.COMMUNITY_PAGE.SIDEBAR.MAIN_BLOCK}>
            {communityDetailsInSidebar && (
              <>
                <UserInfoSection community={community} />
                <Separator color="black10" m="5px 0" />
                {isDraft ? (
                  <CommunityDraftExplanation community={community} />
                ) : isCheck ? (
                  <CommunityCheckExplanation />
                ) : roles?.isMember ? (
                  <Div align="center">
                    <CommunityMembers community={community} fontSize="1em" m="0 0 10px" noEllipsis align="center" />
                    <CommunitySubscriptionButtons
                      trackingSource={TRACKING_SOURCE.COMMUNITY_SIDEBAR}
                      community={community}
                    />
                  </Div>
                ) : (
                  <Div align="center">
                    <CommunityMembers community={community} fontSize="1em" m="0 0 10px" noEllipsis align="center" />
                    <JoinButton
                      community={community}
                      trackingSource={TRACKING_SOURCE.SIDEBAR}
                      w="100%"
                      size="bigger"
                      // No event origin here because it is already on the community's page
                    />
                  </Div>
                )}
              </>
            )}
            {communityDetailsInSidebar && communityShareInSidebar && (
              <>
                <Space />
                <Separator color="black10" m="5px 0" />
              </>
            )}
            {communityShareInSidebar && <CommunitySharesDesktop community={community} />}
          </Block>
        </>
      )}
      <Space />
    </>
  )
}
